"use client";

import { Grid2X2 } from "lucide-react";
import { motion } from "motion/react";
import Link from "next/link";

import { ProductImage } from "@/components/catalog/product-image";
import { homeContent } from "@/data/home-content";
import {
  MotionList,
  MotionListItem,
  useSubtleInteraction,
} from "@/components/ui/motion-primitives";
import type { CatalogFamilySummary } from "@/domain/catalog/catalog-product";

const visibleCategoryCount = 3;
const MotionLink = motion.create(Link);

export interface CategoryShortcutRowProps {
  readonly families: readonly CatalogFamilySummary[];
}

export function CategoryShortcutRow({
  families,
}: Readonly<CategoryShortcutRowProps>) {
  const visibleFamilies = families.slice(0, visibleCategoryCount);
  const interaction = useSubtleInteraction();

  if (visibleFamilies.length === 0) {
    return null;
  }

  return (
    <nav aria-label="Categorías principales">
      <MotionList className="home-category-shortcuts">
        {visibleFamilies.map((family) => (
          <MotionListItem key={family.slug}>
            <MotionLink
              className="home-category-shortcut"
              href={`/categorias/${family.slug}`}
              prefetch={false}
              {...interaction}
            >
              <span className="home-category-shortcut__image">
                <ProductImage
                  alt=""
                  className="h-full w-full object-fit"
                  imageUrl={family.representativeImageUrl ?? family.featuredImageUrl}
                  loading="eager"
                  sizes="72px"
                />
              </span>
              <span className="home-category-shortcut__label">
                {family.shortName ?? family.name}
              </span>
            </MotionLink>
          </MotionListItem>
        ))}

        <MotionListItem>
          <MotionLink
            className="home-category-shortcut home-category-shortcut--all"
            href="/categorias"
            prefetch={false}
            {...interaction}
          >
            <span className="home-category-shortcut__image home-category-shortcut__image--all">
              <Grid2X2 aria-hidden="true" size={26} strokeWidth={2.5} />
            </span>
            <span className="home-category-shortcut__label">
              {homeContent.allCategoriesShortcut}
            </span>
          </MotionLink>
        </MotionListItem>
      </MotionList>
    </nav>
  );
}
